import React, {useEffect} from 'react';
import {Route, Redirect} from 'react-router-dom';
import {useSelector} from 'react-redux';
import ProMinusPopup from 'components/ProMinusPopup/index.js';
import {findRouteDefaultPath} from '../../utils/helpers';

const LoggedOutRoute = ({component: Component, ...rest}) => {
    const auth = useSelector(({global}) => global.auth);
    const uiPageMenu = useSelector(({global}) => global.uiPageMenu);

    return (
        <Route
            {...rest}
            render={(props) =>
                auth === null ? ( // user not authenticated yet so redirect to '/' => auth
                    <Redirect
                        to={{
                            pathname: '/',
                            state: {
                                from: props.location,
                                isProtected: false,
                            },
                        }}
                    />
                ) : !auth ? ( // user is logged out so render component
                    <>
                        <Component {...props} />
                        <ProMinusPopup {...props} />
                    </>
                ) : (
                    // user is logged in so redirect
                    <Redirect
                        to={
                            findRouteDefaultPath(
                                uiPageMenu,
                                props.location?.state?.from,
                            ) ?? {
                                pathname: findRouteDefaultPath(
                                    uiPageMenu,
                                    '/landingpage',
                                ),
                                state: {from: props.location},
                            }
                        }
                    />
                )
            }
        />
    );
};

export default LoggedOutRoute;
